import type { CSSProperties } from 'react';
import type { TraceToolStatus } from '../types';

const TRACE_TEXT_SHIMMER_FG_MUTED = 'var(--colors-fg-muted)';
const TRACE_TEXT_SHIMMER_FG_SUBTLE = 'var(--colors-fg-subtle)';

const TRACE_TEXT_SHIMMER_GRADIENT = `linear-gradient(90deg, ${TRACE_TEXT_SHIMMER_FG_MUTED} 25%, ${TRACE_TEXT_SHIMMER_FG_SUBTLE} 50%, ${TRACE_TEXT_SHIMMER_FG_MUTED} 75%)`;

export function isTraceToolCallSettled(status: TraceToolStatus): boolean {
  return status === 'completed' || status === 'error';
}

export function shouldShowTraceToolShimmer({
  hasResult,
  status,
}: {
  hasResult: boolean;
  status: TraceToolStatus;
}): boolean {
  if (hasResult || isTraceToolCallSettled(status)) {
    return false;
  }

  return true;
}

export function getTraceTextShimmerStyle(
  enabled: boolean,
): CSSProperties | undefined {
  if (!enabled) {
    return undefined;
  }

  return {
    background: TRACE_TEXT_SHIMMER_GRADIENT,
    backgroundSize: '200% 100%',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animationTimingFunction: 'linear',
  };
}
